export default {
  common: {
    language: '언어',
    logoAlt: 'Zhongze Education',
    cancel: '취소',
  },
  chatService: {
    chatNow: {
      label: '지금 채팅하기',
    },
    emailGate: {
      title: '이메일이 필요합니다',
      desc: '채팅을 계속하려면 이메일을 입력해 주세요.',
      successMessage: '이메일이 제출되었습니다. 계속 채팅할 수 있습니다.',
    },
  },
  nav: {
    home: '홈',
    products: '제품',
    software: '소프트웨어',
    eduServices: '교육 서비스',
    support: '서비스 및 지원',
    cooperation: '교육 협력',
    about: '회사 소개',

    // Sub-menus & Mega Menu
    learningPlatform: 'Zhongze Education 학습 플랫폼',
    cloudPlatform: 'Zhongze Education 클라우드 플랫폼',
    laserSoftware: '레이저 장비 전용 소프트웨어',
    makerK12: '메이커 교육 - 초·중등',
    archVocational: '건축 모형 - 중등 직업교육',
    cultHigherVoc: '문화·창작 디자인 - 고등 직업교육',
    artsUni: '예술·공예 - 대학교',
    afterSales: '애프터서비스',
    faq: '자주 묻는 질문',
    download: '다운로드 센터',
    companyIntro: '회사 소개',
    news: '뉴스',
    contact: '문의하기',
    device: '장비',
    kits: '키트',
    softwareService: '소프트웨어 서비스',
    accessories: '액세서리',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: '키트 시스템',
    kitsAccessories: '키트 액세서리',
    courses: '과정',
  },
  aboutPage: {
    seoTitle: '회사 소개 - Zhongze Education',
    banner: {
      title: '회사 소개',
    },
    about: {
      title: '회사 소개',
      body: 'Zhongze Education은 2015년에 설립되었습니다. 홍콩 차이나유니콤 인터내셔널과의 긴밀한 협력을 바탕으로, 유럽·미국의 STEAM 커리큘럼을 토대로 아동에게 적합한 메이커 교육 체계를 자체 개발했습니다. 사회적 상호작용을 통한 학습과 실습을 통해 아이들이 한계를 넘어 놀라운 결과를 만들어 내도록 돕습니다. 우리는 “STEAM 교육 + 메이커 스페이스”를 핵심으로, “미래의 창조자를 양성한다”는 사명을 지키며 3~16세 아동·청소년의 기술 창의성 교육에 집중합니다. 과학기술 창의교육 공간을 운영하고, 과학기술 창의교육 제품과 과정을 자체 개발하며, 학습용 설계 소프트웨어, 레이저 조각, 프로그래밍 등의 모듈을 중심으로 독자적인 교육 콘텐츠 R&D 생태계와 제품 선순환 구조를 구축했습니다. 아이들이 실제 프로젝트 속에서 미래에 필요한 핵심 역량을 기를 수 있도록 합니다! 우리의 비전은 국제적인 과학기술 창의교육의 선도자가 되는 것입니다. 우리는 과정과 메이커 환경을 제공하는 것을 넘어, 새로운 학습 방식을 제안합니다. 모든 아이는 미래의 혁신가라고 믿으며 과학자처럼 탐구하고, 엔지니어처럼 직접 만들고, 디자이너처럼 창의적으로 표현하고, 메이커처럼 배우고 창조하도록 돕습니다. 탐색 속에서 자신을 발견하고, 실천 속에서 미래를 만들어 가도록 합니다.',
    },
    intro: {
      title: '왜 우리를 선택해야 할까요?',
      desc: '국제적인 과학기술 창의교육의 선도자로서 과정과 메이커 환경을 제공하고, 더 나아가 새로운 학습 방식을 제안합니다. 모든 아이는 미래의 혁신가라고 믿으며, 탐색 속에서 자신을 발견하고 실천 속에서 미래를 만들어 가도록 돕습니다.',
      features: {
        projectLearning:
          '프로젝트 기반 학습: 실제 프로젝트를 통해 미래에 필요한 핵심 역량을 기를 수 있습니다.',
        interactiveExperiments:
          '상호작용형 실험: 아이들은 기본 과학 원리를 익히는 것은 물론, 문제 해결 능력·창의력·팀워크를 함께 키울 수 있습니다.',
      },
    },
    images: {
      aboutAlt: 'Zhongze Education 소개',
      featureIcon1Alt: '프로젝트 기반 학습 아이콘',
      featureIcon2Alt: '상호작용형 실험 아이콘',
      introAlt: '왜 우리를 선택해야 할까요',
    },
  },
  newsPage: {
    banner: {
      title: '뉴스',
    },
    tabs: [
      { id: 'all', name: '전체' },
      { id: 'company', name: '회사 뉴스' },
      { id: 'exhibition', name: '전시회 소식' },
      { id: 'industry', name: '업계 동향' },
    ],
    items: [
      {
        title:
          '헝하오 레이저, BETT UK 2025에서 빛나다: 레이저 기술로 교육 혁신을 가속',
      },
      {
        title:
          'K-12 교육 혁신의 핵심: CO2 레이저 커터가 STEAM 수업을 어떻게 이끄는가',
      },
      {
        title:
          '헝하오 레이저 고객, Light 530과 함께 didacta Italia 2025에서 주목받다',
      },
      { title: 'Zhongze Education, 새로운 스마트 교육 솔루션 발표' },
      { title: '미래 교육 트렌드: 인공지능과 메이커 교육의 심층 융합' },
    ],
  },
  newsInformationPage: {
    banner: {
      title: '뉴스',
    },
    tabs: [
      { id: 'all', name: '전체' },
      { id: 'company', name: '회사 뉴스' },
      { id: 'exhibition', name: '전시회 소식' },
      { id: 'industry', name: '업계 동향' },
    ],
    items: [
      {
        title:
          'Zhongze Technology, 차세대 교육용 로봇 키트 출시로 STEM 교육의 새 흐름을 선도',
      },
      {
        title:
          'AI의 학교 진출: 프로그래밍 교육으로 학생의 논리적 사고력을 높이는 방법',
      },
      {
        title:
          '2023 전국 청소년 로봇 대회 성료, Zhongze 지원 팀 우수 성과 달성',
      },
      { title: '미래 교육 탐색: 디지털 전환 시대의 스마트 교실 구축 방안' },
      {
        title:
          'Zhongze Technology, 여러 대학과 전략적 협력 체결… AI 공동 실험실 구축',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: '메이커 교육',
        desc: '실험과 탐구의 공간을 제공해 학생의 전인적 성장을 돕습니다',
      },
      item2: {
        title: '지혜의 문을 열다',
        desc: '레이저 장비 활용부터 키트·과정 학습까지 다양한 학습 니즈를 전방위로 충족합니다.',
      },
      item3: {
        title: '키트 과정',
        desc: '인공지능 ISTEAM 교육 | 과학기술 창의교육, 과정 효율 향상에 필수',
      },
    },
    resources: {
      title: '풍부한 STEM 수업 자료',
      tabs: {
        laser: {
          name: '레이저 커터',
          title: '레이저 장비',
          desc1: '데스크톱 스마트 레이저 커팅·조각기',
          desc2: '고정밀 커팅│스마트하고 간편한 조작│효율적인 가공│안전·친환경',
        },
        software: {
          name: '소프트웨어',
          title: '교육용 소프트웨어',
          desc1: '다방면 올인원 소프트웨어',
          desc2: '클라우드 플랫폼 | 학습 플랫폼 | Light Maker',
        },
        ai: {
          name: 'AI 스마트 수업 보조',
          title: '스마트 수업 보조',
          desc1: '실시간 모니터링 및 장비 알림',
          desc2: 'AI 조교 | 시각화 대시보드',
        },
        kits: {
          name: '키트 및 과정',
          title: '풍부한 과정 키트',
          desc1: 'PBL 프로젝트 기반 학습',
          desc2: '연계 교재 | 실습',
        },
      },
    },
    different: {
      title: '남다른 우리',
      items: {
        solution: {
          title: '교육 AI 솔루션',
          desc: '수업 효과와 학습 경험을 향상',
        },
        course: {
          title: '창의적 사고 과정',
          desc: '3~16세 아동·청소년에게 적합한 과정',
        },
        product: {
          title: '과학기술 창의교육 제품',
          desc: '원클릭 레이저 메이킹',
        },
        space: { title: '메이커 탐구 공간', desc: '혁신성과 실용성의 결합' },
      },
    },
    creative: {
      title: '창의로 이끌고, 미래를 만들다',
      machineDesc: '스마트 데스크톱 레이저 커팅 & 조각기',
      lightBlue530Desc: '스마트 블루 레이저 절단 & 각인 기기',
      markM20Desc: '고정밀 레이저 마킹 장비',
      light640Desc: '전문 데스크톱 레이저 절단 & 각인 기기',
    },
    innovation: {
      title: '혁신 학습을 어떻게 촉진할까요?',
      desc: 'Zhongze Education은 레이저 커터 등 고품질의 과학기술 창의교육 제품 개발에 전념합니다. 이러한 제품은 학생들이 과학, 기술, 공학, 예술, 수학 분야에서 실습 중심 학습을 수행하도록 돕습니다.',
      items: {
        steam: 'STEAM',
        coding: '프로그래밍',
        light530: 'Light 530 사용',
        robotics: '로봇 기술',
      },
    },
    bottomBanner: {
      title: 'AI 교육을 현장에 구현',
      subtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
      desc: '레이저 맞춤형 제품과 기술 서비스에 집중하여 학교와 기업의 [AI+교육] 융합을 지원합니다',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: '레이저 장비 전용 소프트웨어  Light Maker',
      bannerDesc:
        '전문 레이저 장비 소프트웨어로, 간단하고 효율적이며 커팅과 조각 경험에 집중합니다.',
      bannerImageAlt: 'Light Maker 화면',
      creationTitle: '창작을 더 쉽게',
      features: {
        proDesignTool: '전문가급 디자인 도구',
        highPrecisionParams: '고정밀 파라미터 설정',
        multiDeviceControl: '다중 장비 관리·제어',
        assetLibrary: '강력한 소재 라이브러리 관리 시스템',
      },
      intro: {
        imageAlt: '기능 소개',
        items: {
          item1: {
            title: '강력하고 사용하기 쉬운 디자인 시스템',
            desc: '강력한 창작 소프트웨어로 JPG, DXF, AI, DST, PNG, BMP, TIF, SVG 형식의 고품질 디자인과 호환됩니다.',
          },
          item2: {
            title: '전문성',
            desc: '전문적인 드로잉 기능으로 모든 제작 요구를 충족합니다. 복잡한 디자인이든 간단한 커팅이든 손쉽게 처리할 수 있습니다.',
          },
        },
      },
      downloadTitle: '소프트웨어 다운로드',
      downloadButton: '다운로드 체험',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Zhongze Education 학습 플랫폼',
      bannerDescLine1:
        'Zhongze Education 학습 플랫폼은 학생과 교사에게 종합적인 교육용 소프트웨어 솔루션을 제공하기 위한 혁신적인 온라인 학습 도구입니다.',
      bannerDescLine2:
        '모바일 기기든 컴퓨터든 사용자는 손쉽게 플랫폼에 접속해 이용할 수 있습니다.',
      bannerImageAlt: 'Zhongze Education 학습 플랫폼 화면',
      exploreTitle: '무한한 가능성을 탐색하고, 멋진 미래를 창조하세요',
      exploreTabs: [
        { name: '제작' },
        { name: '초보자 시작' },
        { name: '모델링 학습' },
        { name: '원클릭 제작' },
        { name: 'AI 이미지 생성' },
      ],
      tabContentAlt: '기능 소개',
      introTitle: '혁신 학습 플랫폼',
      introItems: [
        {
          title: '효율적인 학습의 새로운 경험',
          desc: 'Zhongze Education 학습 플랫폼은 과정 학습, 그래픽 디자인, 레이저 커팅 기능을 원스톱으로 통합합니다. 카드형 UI는 깔끔하고 직관적이며 조작은 편리하고 부드럽습니다. 아이디어 디자인부터 실물 제작까지 매끄럽게 연결되어 효율적이고 쉽게 시작할 수 있습니다.',
        },
        {
          title: '스마트하고 간편하게, 초보도 걱정 없이',
          desc: '방대한 내장 이미지 라이브러리와 스마트 파라미터 프리셋으로 원클릭 제작을 지원하며, 초보자도 빠르게 익힐 수 있습니다. 모바일의 상세한 가이드 튜토리얼로 부담 없이 시작하고, 클라우드에서 장비 상태를 실시간 모니터링해 수업 안전을 전 과정에서 지켜줍니다.',
        },
      ],
      introImageAlt: '혁신 학습 플랫폼',
      galleryAlt: '플랫폼 미리보기',
      downloadTitle: '소프트웨어 다운로드',
      downloadApps: [
        { name: 'Zhongze Education 플랫폼 App' },
        { name: 'Zhongze 디자인 소프트웨어 PC 버전' },
      ],
      downloadButtonText: '다운로드 체험',
    },
    cloudPlatform: {
      bannerTitle: 'Zhongze Education 클라우드 플랫폼',
      bannerDesc:
        '원스톱 교육 관리 도구로 과제 송수신, 장비 모니터링, 수리 요청 및 파라미터 설정을 지원하여 교사·학생·학교의 효율적인 관리를 돕습니다.',
      bannerImageAlt: 'Zhongze Education 클라우드 플랫폼 화면',
      exploreTitle: '수업 관리 간소화',
      exploreTabs: [
        { name: '제작' },
        { name: '초보자 시작' },
        { name: '심화 학습' },
      ],
      tabContentAlt: '기능 소개',
      introTitle: '교육 효율 향상',
      introItems: [
        {
          title: '조작이 편리함',
          desc: '원클릭 제작: 내장 이미지 라이브러리와 파라미터 설정으로 원클릭 제작을 지원해 조작 과정을 단순화합니다. 장비 모니터링: 장비 상태를 실시간으로 모니터링하여 수업 활동이 원활히 진행되도록 보장합니다.',
        },
        {
          title: '통합 관리',
          desc: '장비 병렬 연결: 메이커 교실의 다른 장비와 병렬 연결을 지원하며, 원클릭 관리 기능으로 관리 효율을 높입니다.',
        },
        {
          title: '실시간 모니터링',
          desc: '장비 상태: 장비의 운영 상태를 실시간으로 파악하고, 고장 발생 시 즉시 수리를 요청할 수 있습니다. 유지보수: 시스템이 장비의 사용 시간과 사용 빈도에 따라 정기적으로 유지보수를 안내하여 장비 수명을 늘리고 커팅 품질을 높입니다.',
        },
      ],
      introImageAlt: '혁신 학습 플랫폼',
      galleryTitle: 'AI 교육을 현장에 구현',
      galleryDesc: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
    },
  },
  eduServices: {
    banner: {
      title: 'AI+교육',
      desc: 'Zhongze Education의 디지털 지능형 교육 솔루션은 국가의 혁신 인재 양성을 지원하며, 교육 발전과 학생 수요를 지향하여 K-12 학교에 전 학년 AI 교육 방안을 제공합니다.',
      imageAlt: '교육 솔루션 배너',
    },
    recommended: {
      title: '추천 제품',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: '올인원 수업 공간 구축',
      tabs: {
        'teaching-assist': '스마트 수업 보조',
        'process-optimize': '수업 프로세스 최적화',
        'device-manage': '장비 관리',
      },
      tabContents: {
        'teaching-assist': {
          title: '스마트 수업 보조',
          features: [
            '·실시간 모니터링 및 장비·소모품',
            '·AI 스마트 학습 보조',
            '·시각화 대시보드',
          ],
        },
        'process-optimize': {
          title: '수업 프로세스 최적화',
          features: [
            '·온라인 과제 배포 및 채점',
            '·원격 중앙 관리로 과정 클라우드 리소스 통제',
          ],
        },
        'device-manage': {
          title: '장비 관리',
          features: ['·교육 장비 실시간 모니터링', '·원격 장비 수리 요청'],
        },
      },
      categories: [
        {
          title: '온라인 과제 배포 및 채점',
          description: '스마트한 과제 관리 시스템으로 수업 효율을 향상',
        },
        {
          title: '원격 장비 수리 요청',
          description: '편리한 원격 장비 유지보수 및 수리 서비스',
        },
        {
          title: '원격 중앙 관리로 수업 프로세스 간소화',
          description: '통합 원격 관리 플랫폼으로 수업 프로세스를 최적화',
        },
        {
          title: '과정 클라우드 리소스',
          description: '풍부한 클라우드 과정 리소스와 교수 자료',
        },
        {
          title: '교육 장비 실시간 모니터링',
          description:
            '장비 상태를 실시간으로 모니터링하여 수업이 원활히 진행되도록 보장',
        },
        {
          title: 'AI 스마트 수업 도우미',
          description: 'AI 기반 스마트 수업 보조 시스템',
        },
      ],
      solutionCards: [
        { title: '과학기술 창의 디지털 지능화 솔루션' },
        { title: '초·중등 스마트 교실 솔루션' },
        { title: '중등·고등 직업교육 역량 솔루션' },
        { title: '대학 AI 교실 솔루션' },
      ],
    },
    solutions: {
      title: '원스톱 교육 솔루션',
      items: [
        {
          title: '장비',
          description:
            'AI가 교육을 고도화하는 환경에서, Henghao 레이저 커터는 스마트 클라우드 플랫폼을 통해 Zhongze 레이저 수업 클라우드 플랫폼과 긴밀하게 연동됩니다. 교사는 장비를 원격으로 관리하고 과제를 배포하며 학생의 진행 상황을 추적할 수 있습니다. 이러한 융합은 수업 효율을 높일 뿐 아니라 학생에게 더 개인화된 학습 경험을 제공합니다.',
          buttonText: '자세히 보기 →',
        },
        {
          title: '소프트웨어',
          description:
            'Zhongze 교육 플랫폼은 AI 기술을 결합해 개인화 학습, 스마트 도구, 상호작용 경험, 클라우드 리소스를 제공합니다. 과정 및 과제 관리, 장비 모니터링·알림, 데이터 분석 등을 지원합니다. Zhongze 학습 플랫폼(APP/PC)과 Light Maker 도구를 함께 사용하면 수업을 전방위로 지원하고 리소스를 최적화하며 교육 혁신을 촉진해 교사·학생·교육 기관에 강력한 지원을 제공합니다.',
          buttonText: '자세히 보기 →',
        },
        {
          title: '과정',
          description:
            'Zhongze 교육의 과학기술 창의 커팅 과정은 청소년을 위해 설계된 체계적·모듈형 커리큘럼으로, 흥미와 잠재력을 이끌어 냅니다. 기술 기초 지식, 혁신적 사고 훈련, 프로젝트 실습, 과학 실험 등을 포괄해 아이들이 미래의 과학기술 인재로 성장하도록 돕고 사회 발전에 기여합니다.',
          buttonText: '자세히 보기 →',
        },
      ],
    },
    managementPlatform: {
      title: 'Zhongze Education 스마트 수업 관리 플랫폼',
      desc: '개인화된 학습 경로, 스마트 수업 도구, 상호작용형 학습 경험, 클라우드 리소스 라이브러리를 제공하며, 과정 관리, 학생 진행 추적, 온라인 과제, 수업 장비 실시간 모니터링 및 알림, 데이터 분석 등의 기능을 지원합니다. AI 기술을 융합해 수업 효과를 높이고 교육 자원의 최적 배치를 실현하여 학생·교사·학교·교육 기관에 전방위 교육 지원을 제공하고 교육의 발전과 혁신을 함께 추진합니다.',
      items: [
        {
          title: '과학기술 창의 디지털 지능화 솔루션',
          alt: '과학기술 창의 디지털 지능화 솔루션',
        },
        {
          title: '초·중등 스마트 교실 솔루션',
          alt: '초·중등 스마트 교실 솔루션',
        },
        {
          title: '중등·고등 직업교육 역량 솔루션',
          alt: '중등·고등 직업교육 역량 솔루션',
        },
        { title: '대학 AI 교실 솔루션', alt: '대학 AI 교실 솔루션' },
      ],
      action: {
        text: '맞춤형 솔루션 받기',
        alt: '문의하기 아이콘',
      },
    },
  },
  makerK12: {
    banner: {
      title: '과학기술 메이커 — 초·중등',
    },
    intro: {
      title: '학교 교육에서의 레이저 커터',
      desc: '학교에서 레이저 커터를 사용하면 아이디어부터 완성품까지 안전하고, 비접촉식이며, 디지털 방식으로 진행됩니다. 아이들의 기발한 상상을 손쉽게 실현할 수 있습니다.',
      imageAlt: '건축 모형 제작 중인 레이저 커터',
    },
    scenesFeatured: {
      title: '첨단 교육 도구로 학습 방식을 바꾸다',
      desc: '학생들에게 업계를 선도하는 기술을 제공하여 창의력, 비판적 사고, 기술 역량을 향상합니다.',
    },
    scenes: {
      items: [
        {
          title: '모든 학생을 위한 레이저 창작 플랫폼',
          desc: '학생의 참여 역량을 강화하고, 강력한 도구를 활용해 수업에서 창의적 사고를 기를 수 있도록 돕습니다.',
        },
        {
          title: '전자 및 프로그래밍 키트',
          desc: '상호작용형 키트를 통해 학생들이 직접 프로그래밍, 로봇 기술, 인공지능을 체험하며 학습하도록 합니다.',
        },
        {
          title: '직업 기술 교육',
          desc: '레이저 기술 플랫폼으로 진로 역량과 기술을 강화해 변화하는 고용 시장에 대응하고 더 많은 기회를 만듭니다.',
        },
      ],
    },
    solutions: {
      title: '건축 모형은 다양한 분야에 폭넓게 활용됩니다',
      items: [
        { title: 'K-12 학교/학군' },
        { title: '교육 기관' },
        { title: '연구실 및 전공 과정' },
        { title: '메이커 스페이스' },
        { title: '건축 도서관/박물관' },
        { title: '창의 과정' },
      ],
    },
    bannerLeft: {
      title: 'AI 교육을 현장에 구현',
      subtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
    },
    products: {
      tabs: [
        {
          title: '레이저 장비',
          title1: '메이킹 필수 장비 - 레이저 커터',
          description:
            'Light 530과 640은 최상급 부품, 고품질 제조 공정, 엄격한 검사 절차를 결합해 완성된 고성능 레이저 장비입니다. 안정성이 뛰어나고 커팅·조각 정밀도가 높아, 과학기술 창의교육 현장에서 요구되는 레이저 창작 니즈를 완벽하게 충족합니다.',
        },
        {
          title: '소프트웨어',
          title1: '드로잉 전문가 - LightMaker',
          description:
            '학생에게 안전성, 속도, 스마트 기능과 시장에서 가장 혁신적인 기술 설계를 제공합니다. LightMaker는 AI, PS, CorelDRAW, AutoCAD, Solidworks 등 다양한 디자인 소프트웨어와 호환되며, JPG, DXF, AI, DST, PNG, BMP, TIF, SVG 등 고품질 파일 업로드를 지원합니다.',
        },
        {
          title: '과정',
          title1: '다채로운 수업 - 과학기술 창의교육 과정',
          description:
            '모든 아이는 각기 다르다는 점을 잘 알고 있기에, 우리의 과정은 유연하고 다양하게 설계되어 학생 개개인의 흥미와 잠재력을 이끌어 냅니다. 과정 내용은 기술 기초 지식, 혁신적 사고 훈련, 프로젝트 실습, 과학 실험 등을 포함하며 이에 한정되지 않습니다.',
        },
      ],
    },
    learning: {
      title: '수업에서 Zhongze 레이저 커터를 어떻게 활용할까요?',
      teacher: {
        title: '교사',
        lines: [
          '수업 교구 및 교재 부속 제작',
          '레이저 커터는 교사가 교구와 수업 자료를 높은 효율로 제작하도록 돕고, 더 새롭고 창의적인 수업 방식도 설계할 수 있게 합니다.',
        ],
      },
      student: {
        title: '학생',
        lines: [
          '실습 역량 강화',
          '수업에서 레이저 커터는 디자인, 공학, 과학기술 등 융합 분야 학습을 돕는 도구로서, 학생의 상상을 실제 결과물로 구현하도록 지원합니다.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: '건축 모형 제작 장면 1' },
        { alt: '건축 모형 제작 장면 2' },
        { alt: '건축 모형 제작 장면 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: '건축 모형 - 중등 직업교육',
    },
    intro: {
      title: '레이저 커터는 건축 모형 제작에 어떻게 활용될까요?',
      desc: '레이저 커팅과 조각을 활용해 건축 모형 제작은 물론, 완구 산업의 모형 제작에서 가장 작은 부품까지 가공할 수 있습니다. 섬유, 플라스틱, 목재, 합판, MDF, PMMA, 골판지, 종이, 폼, 발포 폴리스티렌, 필름, 아크릴 등 다양한 소재를 빠르고 정밀하게 커팅할 수 있습니다.',
      imageAlt: '건축 모형 제작 중인 레이저 커터',
    },
    scenesFeatured: {
      title: '건축 모형 제작의 혁신 동력',
      desc: '정교한 미니어처 샘플과 고품질 건축 모형 제작을 도와, 창의적인 설계 청사진을 섬세하게 구현합니다.',
    },
    scenes: {
      items: [
        {
          title: '고정밀',
          desc: '레이저 커터는 매우 높은 정밀도로 소재를 절단하며 오차를 극히 작은 범위로 제어할 수 있어, 건축 모형의 각 부품 치수가 정확하고 설계 도면 요구에 완벽히 부합하도록 보장합니다.',
        },
        {
          title: '다양한 소재',
          desc: '목재의 자연 질감, 아크릴의 투명함과 광택, 종이의 가벼움과 가공성 등은 레이저 커팅·조각을 통해 고유한 매력을 그대로 표현할 수 있습니다.',
        },
        {
          title: '복잡한 형상 처리에 강함',
          desc: '건축 모형에서 흔히 필요한 복잡한 기하 형상과 정교한 디테일도 레이저 커팅으로 손쉽게 구현할 수 있습니다. 곡선, 비정형 구조 등 다양한 형태를 지원해 모형 제작에 더 큰 창의 공간을 제공합니다.',
        },
      ],
    },
    solutions: {
      title: '건축 모형은 다양한 분야에 폭넓게 활용됩니다',
      items: [
        { title: '교육 및 학술 연구' },
        { title: '모형 제작 및 완구 산업' },
        { title: '장식 요소 및 건축 특징' },
        { title: '부동산 및 도시 계획' },
        { title: '건축 장식 및 인테리어' },
      ],
    },
    bannerLeft: {
      title: 'AI 교육을 현장에 구현',
      subtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
    },
    products: {
      tabs: [
        {
          title: ' 적합한 장비',
          title1: '적합한 장비 선택',
          description:
            '레이저 장비는 학생의 아이디어를 빠르게 실물로 전환할 수 있게 합니다. 모형 제작, 디자인, 예술 창작 등 어떤 작업이든 손쉽게 구현할 수 있습니다. 단순한 수공예부터 복잡한 기계 설계까지, 레이저 커터와 조각기는 작업을 정밀하게 수행하여 학생이 실습 속에서 배우고 성장하도록 돕습니다. ',
        },
        {
          title: '자체 설계',
          title1: '자체 설계',
          description:
            '디자인을 직관적으로 수정하고 최종 결과를 미리 볼 수 있습니다. 다양한 소재에서 어떤 디자인의 디테일이든 커팅하고 재현할 수 있으며, 텍스트·로고·이미지·사진을 활용해 작품을 최적화할 수 있습니다. 건축 모형을 빠르게 꾸밀 수 있습니다.',
        },
        {
          title: '시장',
          title1: '학생 역량 향상',
          description:
            '휴대형 레이저 마킹기는 건축 모형의 표기와 디테일 조각에 적합합니다. 조작이 간단하고 휴대가 편리해 건축 교육에 필수적인 도구입니다.',
        },
      ],
    },
    learning: {
      title: '다학제 과정 수업',
      groups: [
        {
          title: '미니어처 모형',
          lines: [
            '정확하고 섬세해 미니어처 제작 요구를 충족',
            '다양한 소재에서 레이저 조각/커팅 디테일을 정교하게 표현하여 번거로운 공정을 줄이고, 효율적인 창작을 경험하며 수작업 오차를 감소시킵니다.',
          ],
        },
        {
          title: '실내 디자인',
          lines: [
            '디자인 디테일을 한 번에 구현하고, 내장 카메라로 대상의 위치·크기를 손쉽게 미리 볼 수 있어 보는 대로 결과가 나옵니다. 커팅/조각 작업을 효율적으로 수행하고 소재 손실을 줄입니다.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '건축 모형 제작 장면 1' },
        { alt: '건축 모형 제작 장면 2' },
        { alt: '건축 모형 제작 장면 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: '예술·공예 - 대학교',
    },
    intro: {
      title: '레이저 장비로 예술·공예품을 가공하는 방법',
      desc: '이 장비는 학생이 아이디어를 실물로 전환할 수 있는 플랫폼을 제공하여 혁신적 사고와 창의력을 자극합니다. 학생들은 레이저 종이 커팅, 스탬프 등 다양한 독창적인 모형과 작품을 디자인할 수 있습니다.',
      imageAlt: '예술·공예품 가공 중인 레이저 장비',
    },
    scenesFeatured: {
      title: '기술 역량 개발',
      desc: '학생은 레이저 커팅·조각기를 직접 다루며 재료 과학과 가공 기술에 대한 심화 지식을 배우고, 실습 능력과 문제 해결 능력을 향상할 수 있습니다.',
    },
    scenes: {
      items: [
        {
          title: '창의적 사고 자극',
          desc: '레이저 커팅·조각기는 모형과 작품 제작 등 학생의 창의적 디자인을 구현하는 데 활용되어 창의력을 강화합니다.',
        },
        {
          title: '다학제 융합',
          desc: '레이저 커팅·조각 기술은 물리, 화학, 재료 과학, 컴퓨터 과학 등 여러 학문 지식을 포함합니다. 대학 교육에서 학제 간 융합을 촉진해 학생의 종합 역량을 기를 수 있습니다.',
        },
        {
          title: '실습 수업 프로젝트',
          desc: '레이저 커팅·조각 기술은 대학의 실습 프로젝트(공학 훈련, 예술 디자인, 문화·창작 등)에 활용될 수 있습니다. 예를 들어 학생은 레이저 커팅·조각기로 건축 모형, 기계 부품, 예술 조각 등을 제작하며 이론 지식과 실습을 결합할 수 있습니다.',
        },
      ],
    },
    solutions: {
      title: '대학 공예품 제작에서의 활용',
      items: [
        { title: '맞춤형 소매 제품' },
        { title: '선물 개인화' },
        { title: '명절 마케팅' },
        { title: '주얼리 액세서리' },
        { title: '의류 개인화' },
      ],
    },
    bannerLeft: {
      title: 'AI 교육을 현장에 구현',
      subtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
    },
    products: {
      tabs: [
        {
          title: ' 적합한 장비',
          title1: '적합한 장비 선택',
          description:
            '적합한 레이저 커팅·조각 장비를 선택하면, 대학은 학생에게 선진적인 실습 교육 도구를 제공해 창의력을 자극하고 수업의 질과 효율을 함께 높일 수 있습니다.',
        },
        {
          title: '자체 설계',
          title1: '자체 설계',
          description:
            '디자인을 직관적으로 수정하고 최종 결과를 미리 볼 수 있습니다. 다양한 소재에서 어떤 디자인의 디테일이든 조각하고 재현할 수 있으며, 텍스트·로고·이미지·사진을 활용해 작품을 최적화할 수 있습니다. 레이저 조각기는 조작이 매우 쉽고, 작품을 빠르게 꾸밀 수 있습니다.',
        },
        {
          title: '예술·디자인',
          title1: '예술·디자인 전공 수업',
          description:
            '예술 디자인, 산업 디자인 등 전공에서 레이저 커팅·조각기는 수업 설계와 졸업 작품 프로젝트에 널리 활용됩니다. 학생은 레이저 커팅·조각기를 이용해 디자인 아이디어를 빠르게 실물 작품으로 전환하며 제품 프로토타입 개발 역량을 훈련할 수 있습니다.',
        },
      ],
    },
    learning: {
      title: '레이저를 학교로',
      groups: [
        {
          title: '정확하고 효율적, 시간과 노력 절감',
          lines: [
            'Zhongze 레이저 커터는 카메라 미리보기를 지원해 정확히 정렬할 수 있으며, 소재를 낭비하지 않아 초보자도 쉽게 시작할 수 있습니다。',
            '사용이 매끄럽고 간단해 소재를 넣기만 하면 창의적으로 디자인할 수 있으며, 보는 그대로 결과가 나옵니다。',
            '정밀하게 제작해 소재를 효율적으로 활용하고, 시간·노력·재료를 절약합니다。',
          ],
        },
        {
          title: '고출력 성능, 다양한 소재를 손쉽게 처리',
          lines: [
            '고출력 CO₂ 레이저를 탑재해 조각과 커팅을 모두 수행합니다。',
            '아크릴, 목재, 대나무 등 다양한 소재를 손쉽게 커팅·조각할 수 있어, 공예 애호가를 위한 친화적인 제작 흐름을 구축해 창작을 더 쉽고 효율적으로 만듭니다。',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: '예술·공예품 제작 장면 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: '문화창의 디자인—고등직업교육',
    },
    intro: {
      title: '문화창의 디자인에서의 레이저 장비',
      desc: '고등직업교육 기관의 문화창의 디자인 전공은 보통 레이저 조각기 등 첨단 레이저 커팅·조각 장비를 갖추고 있으며, 이러한 장비는 학생의 단계별 실습 교육 요구를 충족할 수 있습니다。',
      imageAlt: '문화창의 디자인에서의 레이저 장비',
    },
    scenesFeatured: {
      title: '창의성과 품질의 무한한 가능성을 열다',
      desc: '뛰어난 성능과 정밀한 커팅 능력으로 문화창의 디자이너에게 없어서는 안 될 든든한 도구가 됩니다。',
    },
    scenes: {
      items: [
        {
          title: '고정밀 커팅으로 디자인 디테일을 완벽 구현',
          desc: '문화창의 디자인의 복잡하고 정교한 문양과 독특한 형태도 레이저 커터가 정밀하게 재현해, 최종 제품에 모든 디테일이 정확하게 표현되도록 보장합니다。',
        },
        {
          title: '다양한 소재 가공',
          desc: '레이저 장비는 목재, 아크릴, 가죽, 금속 등 다양한 소재를 가공할 수 있어 문화창의 제품 디자인에 폭넓은 소재 선택지를 제공합니다。',
        },
        {
          title: '지능형 조작으로 창작 구현 과정을 단순화',
          desc: '학생은 설계한 도안을 컴퓨터에 입력하기만 하면 레이저 커터가 자동으로 인식해 정밀 커팅을 수행합니다。이러한 지능형 조작 방식은 운영자의 전문 기술 요구를 낮추고, 생산 과정의 안정성과 신뢰성을 높입니다。',
        },
      ],
    },
    solutions: {
      title: '더 많은 좋은 디자인이 일상으로',
      items: [
        { title: '문화 테마 장식 그림' },
        { title: '창의 조명 디자인' },
        { title: '홈 데코 소품과 액세서리' },
        { title: '연필꽂이 및 문구 수납함' },
        { title: '민족풍 액세서리' },
        { title: '여행 기념품' },
      ],
    },
    bannerLeft: {
      title: 'AI 교육을 현장에 구현',
      subtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
    },
    learning: {
      title: '고등직업교육 문화창의 디자인의 제작 도구',
      groups: [
        {
          title: '개인 맞춤 제작',
          lines: [
            '레이저 커팅·조각기는 사진, 이름, 특수 패턴 등의 개인 맞춤 제작을 손쉽게 구현해, 독특하고 기념 의미가 있는 선물을 원하는 소비자 수요를 충족합니다。',
            '예를 들어, 목재 소품, 가죽 액세서리, 아크릴 장식품 등 문화창의 제품에 소비자가 지정한 도안이나 문구를 새겨 더 높은 개인화를 구현할 수 있습니다。',
          ],
        },
        {
          title: '문화창의 파생상품 제작',
          lines: [
            '박물관의 문화창의 기념품부터 영화·애니메이션 파생상품까지, 레이저 커팅·조각기는 복잡한 디자인을 시각화하고 상품화할 수 있게 합니다。',
            '명승고적, 랜드마크 건축물, 문화 IP 등의 요소를 현실 제품으로 전환할 수 있으며, 예를 들어 평범한 목판을 독특한 문양과 형태의 장식품으로 커팅하거나, 일반 종이를 정교한 예술 작품으로 조각할 수 있습니다。',
          ],
        },
        {
          title: 'DIY 창작',
          lines: [
            '레이저 장비는 공예 애호가가 더 높은 수준의 DIY 창작을 구현하도록 돕고 있으며, 소형 공예품부터 독특한 홈 데코까지 레이저 기술로 빠르게 구현할 수 있습니다。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '문화창의 디자인 장면 1' },
        { alt: '문화창의 디자인 장면 2' },
        { alt: '문화창의 디자인 장면 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: '교육 협력',
    },
    advantages: {
      title: '우리의 협력 강점',
      items: [
        {
          title: '경험 풍부한 R&D 팀',
          desc: 'Zhongze 과학교육은 엔지니어와 STEM 교육 종사자로 구성된 전문 팀을 보유하고 있으며, 높은 교육 표준에 부합하면서도 학생의 흥미를 끄는 혁신 제품을 지속적으로 개발합니다。',
        },
        {
          title: 'AI+교육 디지털 지능화 역량 강화',
          desc: 'Zhongze 교육 스마트 플랫폼: 개인화 학습, 스마트 도구, 인터랙티브 경험을 제공하며, 과정 관리, 진도 추적, 과제 제출, 장비 모니터링 및 데이터 분석을 지원합니다. 클라우드 리소스가 풍부해 수업이 더 효율적입니다。',
        },
        {
          title: '풍부한 키트 및 커리큘럼 체계',
          desc: '초급부터 고급까지 레이저 커팅, 스마트 홈, 스마트 교통 등 과정을 제공하여 다양한 연령대 학생의 요구를 충족합니다。',
        },
      ],
    },
    modes: {
      title: '협력 모델',
      carouselAlts: ['교육 협력 장면', '교육 협력 수업', '교육 협력 실습'],
      items: [
        {
          title: '커리큘럼 도입',
          desc: '협력 기관은 우리의 커리큘럼 체계를 직접 도입해 수업 품질을 빠르게 높일 수 있습니다。',
        },
        {
          title: '키트',
          desc: '키트는 3-16세 아동을 위해 설계되었으며, 안전하고 조작이 쉬운 실험 재료를 통해 과학, 기술, 공학, 예술, 수학(STEAM)에 대한 흥미를 자극합니다。',
        },
        {
          title: '제품 협력',
          desc: '협력 기관은 레이저 커터 등 우리의 교육 제품을 구매해 수업과 학생 실습에 활용할 수 있습니다。',
        },
        {
          title: '공동 R&D',
          desc: '협력 기관이 과정 및 제품의 연구개발에 참여해 함께 교육 혁신을 추진하는 것을 환영합니다。',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'AI 교육을 현장에 구현',
        'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: '다운로드 센터',
      sectionTitle: '소프트웨어 다운로드',
      downloadButtonText: '클라이언트 다운로드',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'Zhongze 과학교육 학습 플랫폼 앱' },
        { name: 'Zhongze 과학교육 학습 플랫폼' },
      ],
    },
    afterSales: {
      bannerTitle: '애프터서비스',
      serviceTitle: 'AR 스마트 서비스',
      serviceItems: [
        {
          title: '원격 진단',
          desc: 'AR 원격 안내: 기술 지원 팀이 장비 상태를 실시간으로 확인해 빠르게 고장을 진단하고, 정확한 해결 방안을 제시합니다。',
        },
        {
          title: '가상 수리',
          desc: 'AR 조작 시연: 수리 단계를 가상으로 보여 주어 직관적이고 이해하기 쉬우며, 방법을 쉽게 익히도록 돕습니다。',
        },
        {
          title: '스마트 튜토리얼',
          desc: 'AR 인터랙티브 학습: 장비에서 바로 조작 안내를 확인할 수 있어 효율적이고 편리합니다。',
        },
        {
          title: '빠른 대응',
          desc: 'AR 즉시 지원: 빠르게 대응해 대기 시간을 줄이고, 문제 해결을 더 효율적으로 합니다。',
        },
      ],
      videosTitle: '사용 안내 영상',
      playButtonText: '영상 재생',
      videos: [
        { title: '포장 개봉 시연 영상' },
        { title: '장비 통신 연결 방법' },
        { title: 'Light 530 사용 튜토리얼' },
        { title: '언박싱 설치 튜토리얼' },
        { title: '소프트웨어 기본 조작' },
        { title: '자주 발생하는 고장 점검' },
      ],
      manualsTitle: '사용 설명서',
      viewPdfButtonText: 'PDF 보기',
      manuals: [
        { title: 'Light 530 사용 설명' },
        { title: 'Light 640 사용 설명' },
        { title: 'Blue 530 사용 매뉴얼' },
        { title: 'M20 유지보수 가이드' },
        { title: '레이저 커팅 안전 매뉴얼' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: '3대 키트 시리즈',
      bannerDesc:
        '키트는 개인화 학습을 지원해 다양한 연령대와 학습 요구에 맞추며, 교사에게 풍부한 교수 자료와 도구를 제공해 더 효율적으로 수업하고 지도할 수 있도록 돕습니다。',
      sections: {
        educationTitle: '교육 키트',
        educationDesc: '혁신적 사고와 창의력 함양',
        creativityTitle: '창의로 이끌어, 미래를 만들다',
        projectsTitle: '다양한 교육 프로젝트',
      },
      kitsTabs: [
        {
          name: '레이저 커팅 입문 키트',
          title: '레이저 커팅 입문 키트\n(목판 소모품 포함)',
          desc: '레이저 커팅 STEAM 과정은 다중지능 이론, STEAM 교육 이념 및 프로젝트 기반 학습 이론을 바탕으로 설계되어, 다양한 연령대 학생의 혁신 역량, 비판적 사고, 문제 해결 능력, 소통 및 팀 협업 정신을 기릅니다。 ',
        },
        {
          name: '신기한 과학 보물상자',
          title:
            '신기한 과학 보물상자\n(목판 + 마이크로 회로 키트 패키지 포함)',
          desc: '과정은 《의무교육 과학 교육과정 표준(2022년판)》에 맞추어 설계되었으며, 과학 개념·과학적 사고·탐구 실천·태도와 책임의 4가지 차원을 중심으로 학생의 핵심 역량을 기릅니다。각 수업에서 하나의 과학 작품을 완성하며, 전통 기술·기술 공학·사회 등 핵심 개념을 포괄해 학생이 과학자처럼 사고하도록 이끌고 탐구 능력을 높이며 과학적 사고를 구축합니다。',
        },
        {
          name: '인공지능 프로그래밍 키트',
          title: '인공지능 프로그래밍 키트',
          desc: '미래 기술 탐험은 인공지능 프로그래밍 키트에서 시작합니다。스마트 농장·스마트 홈·스마트 교통·스마트 공장 키트를 통해 각각 농업 기술을 이해하고, 현대 생활을 체험하며, 교통 효율을 탐구하고, 지능형 제조를 알아갑니다。실습을 통해 혁신적 사고를 자극하고 문제 해결 능력을 기르며, 스마트한 세상을 맞이하도록 돕습니다。',
        },
      ],
      creativityItems: [
        {
          title: '실습 역량 강화',
          desc: '이 키트들은 STEMA(과학·기술·공학·예술·수학) 교육을 융합해, 손으로 직접 조작하고 프로젝트를 수행하는 과정에서 학생의 실습 역량과 문제 해결 능력을 전반적으로 향상시킵니다。',
        },
        {
          title: '혁신적 사고 함양',
          desc: '학생이 창의적으로 설계하고 실험하도록 장려해 혁신적 사고와 창의력을 기릅니다。팀 프로젝트를 통해 소통과 협업 능력을 향상시킵니다。。',
        },
        {
          title: '교사 수업 지원',
          desc: '학생이 창의적으로 설계하고 실험하도록 장려해 혁신적 사고와 창의력을 기릅니다。팀 프로젝트를 통해 소통과 협업 능력을 향상시킵니다。',
        },
      ],
      projectItems: [
        { title: '과학' },
        { title: '기술' },
        { title: '프로그래밍' },
        { title: '예술' },
      ],
      bottomBannerText:
        '과정은 손으로 직접 조작하고 프로젝트를 수행하는 방식으로 학생의 실습 역량을 강화하고 실제 문제를 해결하도록 돕습니다；혁신적 사고와 창의력을 기르며 창의적 설계와 실험을 장려합니다。팀 프로젝트를 통해 소통·협업 능력을 높이고 협력을 학습합니다。최신 기술과 도구를 접해 학생이 미래 사회의 요구에 적응하도록 돕습니다。',
    },
    courses: {
      bannerTitle: '커리큘럼 체계',
      bannerDesc:
        '다양한 연령대 학생을 위해 설계된 체계적인 STEAM 과정으로, 과학·기술·공학·예술·수학을 융합해 미래의 혁신 인재를 양성합니다。',
      bannerAlt: '커리큘럼 체계',
      bottomBannerAlt: '커리큘럼 체계 과정 소개',
      sections: {
        kitsTitle: '커리큘럼 키트',
        kitsDesc: '하드웨어와 소프트웨어의 완벽한 결합',
        seriesTitle: '프리미엄 과정 시리즈',
      },
      courseTabs: [
        {
          name: '연령 3-6세',
          title: '과학 탐구 체계-유아 (6개 수업)',
          desc: '일상에서 흔히 볼 수 있는 현상을 바탕으로 과학 교구로 더 깊이 탐구하여, 사물의 발달 규칙과 원리를 이해합니다。',
        },
        {
          name: '연령 6-12세',
          title: 'STEAM 메이커 체계-청소년 (3개 수업)',
          desc: '자신의 아이디어를 발휘해 장비를 활용하고 직접 실습하여, 창의를 작품으로 구현합니다。',
        },
        {
          name: '연령 8-13세',
          title: '레이저 커팅 과정 체계 (3개 수업)',
          desc: '장비를 활용해 다양한 구조 부품을 커팅하고 입체 구조로 조립하며 구조를 미화할 수 있습니다。프로그래밍 역량：프로그래밍 판단의 논리와 원리를 이해합니다。',
        },
        {
          name: '연령 6-15세',
          title: '인공지능 과정 체계 (4개 수업)',
          desc: '장비 도구를 사용해 작품의 외형을 설계·제작하고, 프로그래밍으로 작품을 스마트하고 간편하게 만들며 생활 속 문제를 해결할 수 있습니다。프로그래밍 역량：프로그래밍 판단의 논리와 원리를 이해하고 Arduino 프로그래밍 문법을 학습합니다。',
        },
      ],
      introItems: [
        {
          title: '실습 중심',
          desc: '과정 설계는 실습을 중시하며, 학생은 레이저 커터 등 장비를 직접 조작해 이론을 실무 기술로 전환합니다。',
        },
        {
          title: '혁신적 사고 함양',
          desc: '과정은 학생의 창의적 설계와 제작을 장려하여 혁신적 사고와 문제 해결 능력을 기릅니다。',
        },
        {
          title: '프로젝트 기반 학습',
          desc: '과정은 프로젝트 기반 학습을 채택해, 구체적인 프로젝트 과제를 완수하는 과정에서 학생이 실습으로 지식과 기술을 익히고 습득합니다。',
        },
        {
          title: '첨단 기술 탐구',
          desc: '프로젝트 기반 학습을 통해 학생은 구체적인 프로젝트 과제를 수행하며 실습으로 학습하고 지식을 습득합니다。',
        },
        {
          title: '체계적 교육',
          desc: '과정은 초급에서 중급까지 단계적으로 심화되며, 레이저 커팅 기술을 체계적으로 지도해 학생이 탄탄한 지식 체계를 구축하도록 돕습니다。',
        },
        {
          title: '흥미와 도전의 조화',
          desc: '과정 설계는 재미와 도전을 모두 갖추어 학생의 학습 흥미와 탐구 욕구를 자극합니다。',
        },
      ],
      courseListRow1: [{ name: '스마트 농장' }, { name: '스마트 홈' }],
      courseListRow2: [{ name: '스마트 교통' }, { name: '스마트 공장' }],
      bottomBannerText:
        '과정은 실습 조작, 혁신적 사고, 융합 학습을 특징으로 하며 프로젝트 기반 학습을 통해 학생이 흥미와 도전 속에서 첨단 기술을 익히도록 합니다。체계적 교육, 안전 교육, 개인화 학습을 결합해 손으로 만드는 능력, 팀워크, 문제 해결 능력을 기르고, 성과 발표를 장려해 학생의 성취감을 높입니다。',
    },
    kitsAccessories: {
      bannerTitle: '키트 부품',
      accessories: [
        { name: 'RGB LED 스트립' },
        { name: 'DS1307 시계 모듈' },
        { name: 'DHT11 온습도 센서' },
        { name: '인체 감지 센서' },
        { name: 'LED 조명 모듈' },
        { name: '팬 모듈' },
        { name: '슬롯형 포토인터럽터 스위치' },
        { name: '버튼 모듈' },
        { name: '컨트롤 보드' },
        { name: '확장 보드' },
        { name: '빗방울 센서' },
        { name: 'TT 모터(어댑터 보드 포함)' },
        { name: '적외선 감지 모듈' },
        { name: '적외선 리모컨' },
        { name: '가스' },
        { name: '4자리 7세그먼트 모듈' },
        { name: '매트릭스 키패드' },
        { name: '조도 센서' },
        { name: '신호등 모듈' },
        { name: '부저' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: '스마트 데스크톱 레이저 커팅 & 조각기',
      sections: {
        advantages: '우리의 강점',
        aiTitle: 'AI 교육을 현장에 구현',
        aiSubtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
        carouselTitle: '빛으로 새기는 무한한 가능성',
        specsTitle: '제품 사양',
      },
      bannerFeatures: [
        '지점 촬영 / 트레이싱 / 안전 보호',
        'STEAM 교육과 메이커를 위해 개발',
      ],
      softwareSection: {
        title: '조작이 간단하면서도 강력한 레이저 커팅 시스템',
        items: [
          '가공 소재에 따라 커팅, 깊은 조각, 얕은 조각, 스캔 등 서로 다른 공정 파라미터를 설정할 수 있습니다。',
          '풍부한 도면 소재로 사용자의 디자인 효율을 높입니다。',
          '카메라는 지점 촬영과 도형 보조 설계를 지원해 아이디어를 현실로 만듭니다。',
        ],
      },
      advantages: [
        {
          tagTitle: '고품질·고정밀 레이저',
          desc: '예: 정품 수입 CO₂ 레이저 튜브, 파장 10640nm, 50W 연속 레이저 출력을 제공합니다。최대 커팅 두께는 15mm(아크릴)까지 가능합니다。작업 속도는 1000mm/s, 반복 위치 정밀도는 0.025mm입니다。정밀함을 보장하여 정교한 창작 작품을 빠르고 정확하게 커팅·조각할 수 있습니다。',
        },
        {
          tagTitle: '일체형 3중 배기가스 필터 시스템',
          desc: '필터망, 활성탄, UV 오존층 등 다양한 연기·먼지 필터 시스템을 일체형 송풍 구조로 설계하여 더 청결하고 친환경적이며, 제품 설치도 더 편리하고 컴팩트합니다。별도의 필터 박스를 추가 구매하거나 더 많은 공간을 차지할 필요가 없습니다。',
        },
        {
          tagTitle: '최우선 안전 보호',
          desc: 'SGS 실험실 최고 수준의 안전 테스트를 통과하고, FDA 인증을 받은 Class I 레이저 제품입니다。독특한 안전 및 작동 상태 표시등 설계로 기기의 운전 상태를 직관적이고 명확하게 파악할 수 있습니다。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: '레이저 유형', value: '밀봉식 CO₂ 유리 레이저 튜브' },
          { label: '레이저 헤드 승강 스트로크', value: '≤25mm' },
          { label: '적재 가능 소재 두께', value: '≤22mm' },
          { label: '초점 방식', value: '자동 초점, 수동 초점' },
          { label: '연결 방식', value: 'USB/랜/Wi‑Fi 연결 지원' },
          { label: '지원 OS', value: 'Windows, iOS' },
          {
            label: '지원 디자인 소프트웨어',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks 등',
          },
          {
            label: '지원 파일 형식',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG 등',
          },
          { label: '레이저 수명', value: '≤9000시간' },
          {
            label: '소프트웨어',
            value: 'LightMaker(PC&모바일), Lightburn(PC)',
          },
          {
            label: '제어 방식',
            value: '5인치 LCD 터치스크린/모바일 앱/PC 소프트웨어',
          },
          { label: '작동 소음', value: '≤60dB' },
          {
            label: '구동 방식',
            value: '고속 스테퍼 모터 + 고정밀 리니어 가이드 + 동기 벨트',
          },
          {
            label: '안전 보호',
            value:
              '인터록 스위치(뚜껑 열림 시 정지), 충돌 시 정지, 비상 버튼, 안전 키, 작동 상태 표시등, 수조 고온 경보',
          },
          { label: '전원', value: '230V/110VAC 50HZ/60HZ' },
          { label: '기기 무게', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          { label: '냉각 방식', value: '내장 수랭 시스템(활성수)' },
          { label: '작동 전압', value: 'DC 24V 공랭 + 알루미늄 코일' },
          { label: '물탱크 용량', value: '3.2L' },
          { label: '최대 양정', value: '5M' },
          {
            label: '유량',
            value: '1000L/H 또는 외장 전용 CW3000 레이저 전용 냉각기(옵션)',
          },
        ],
        airPumpSpecs: [
          { label: '토출량', value: '50L/min' },
          { label: '소음', value: '≤48dB' },
          { label: '공기압', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: '정격 출력', value: '62W' },
          { label: '풍량', value: '280m³/H' },
          { label: '소음', value: '≤50dB' },
          { label: '전압', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: '수랭 시스템 사양(내장)',
          airPumpTitle: '에어 펌프 사양(내장)',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle: '배기 시스템 사양(외장 일체형) 측면 하부 흡입',
          filterTitle: '필터 시스템',
          filterValue: '활성탄 필터 솜 + 저소음 팬 + 산업용 활성탄 보드',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: '스마트 블루 레이저 커팅 & 조각기',
      sections: {
        advantages: '우리의 강점',
        aiTitle: 'AI 교육을 현장에 구현',
        aiSubtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
        carouselTitle: '빛으로 새기는 무한한 가능성',
        specsTitle: '제품 사양',
      },
      bannerFeatures: [
        '다양한 소재 가공',
        '자신감 있게 창작, 언제든 쉽게 창작',
      ],
      advantages: [
        {
          tagTitle: '컴팩트한 설치 면적',
          desc: '블루 레이저 조각기는 세련되고 현대적이며 컴팩트한 디자인으로, 가정·학교·스튜디오 등 어떤 공간에도 배치하기 좋습니다。금속 바디와 아크릴 커버의 정교한 조합으로 가공 과정을 선명하게 확인할 수 있습니다。',
        },
        {
          tagTitle: '밀폐형 가공으로 안전하게 보호',
          desc: '블루 레이저 조각기는 완전 밀폐형이며, 작업 중 커버를 열면 자동으로 일시 정지합니다。긴급 상황에서는 스위치 하나로 즉시 기기를 끌 수 있어, 가정과 학교에서 사용하기에 적합합니다。',
        },
        {
          tagTitle: '다양한 소재 가공, 수백 종 소재 지원',
          desc: '독특한 형태나 스타일의 제품을 맞춤 제작할 수 있으며, 액세서리를 추가해 컵이나 원형 물체 등 더 다양한 형태의 소재 조각을 구현할 수 있습니다。소규모 비즈니스의 요구에 매우 적합합니다。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: '냉각 시스템',
          airPumpTitle: '에어 펌프 사양',
          airPumpValueOnly: '—',
          exhaustTitle: '배기 시스템',
          filterTitle: '필터 시스템',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: '레이저 유형', value: '블루 레이저' },
          { key: 'laserPower', label: '레이저 출력', value: '20W / 40W' },
          { key: 'maxCutThickness', label: '최대 커팅 두께', value: '≤10mm' },
          { key: 'focusMode', label: '초점 방식', value: '수동 초점' },
          { key: 'connection', label: '연결 방식', value: 'USB 연결' },
          {
            key: 'os',
            label: '지원 OS',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: '소프트웨어',
            value: 'LightBurn(PC)',
          },
          {
            key: 'laserLifetime',
            label: '레이저 수명',
            value: '≥10000시간',
          },
          {
            key: 'maxMaterialThickness',
            label: '적재 가능 소재 두께',
            value: '15mm',
          },
          { key: 'noise', label: '작동 소음', value: '≤60dB' },
          { key: 'engraveSpeed', label: '조각 속도', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: '지원 디자인 소프트웨어',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks 등',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          { key: 'maxSpeed', label: '최대 작업 속도', value: '1000mm/s' },
          {
            key: 'power',
            label: '전원',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          { key: 'workTable', label: '작업 플랫폼 크기', value: '520 × 315mm' },
          { key: 'accuracy', label: '위치 정밀도', value: '±0.01mm' },
          {
            key: 'repeatAccuracy',
            label: '반복 위치 정밀도',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: '전원 요구 사항',
            value: 'AC 220V ±10%，50Hz',
          },
          { key: 'totalPower', label: '정격 소비전력', value: '300W' },
          {
            key: 'transmission',
            label: '구동 방식',
            value: '고속 스테퍼 모터 + 고정밀 리니어 가이드 + 동기 벨트',
          },
          {
            key: 'safety',
            label: '안전 보호',
            value:
              '인터록 스위치(뚜껑 열림 시 정지), 축 리미트, 비상 버튼, 안전 키',
          },
          { key: 'weight', label: '기기 무게', value: '≈50kg' },
          {
            key: 'machineSize',
            label: '기기 크기',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: '고정밀 레이저 마킹기',
      sections: {
        advantages: '우리의 강점',
        aiTitle: 'AI 교육을 현장에 구현',
        aiSubtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
        carouselTitle: '레이저 마킹, 창의 맞춤',
        specsTitle: '제품 사양',
      },
      bannerFeatures: [
        '안전 보장, 이중 스위치 제어, 레이저 보호',
        '고정밀·고속·고안정성의 조각 및 커팅 능력',
      ],
      advantages: [
        {
          tagTitle: '다양한 적용 분야',
          desc: '이 장비는 주얼리 조각, 개인 맞춤 물품, 부품 식별 등 다양한 산업에 적용할 수 있으며, 주얼리, 향수병부터 소형 산업용 명판까지 여러 용도의 맞춤 조각 요구를 충족합니다。',
        },
        {
          tagTitle: '교육 분야의 혁신적 활용',
          desc: 'Mark M20은 산업급 정밀도를 교육 분야에 도입해, "과학기술 창의교육의 “만능 도우미”"가 되어 학생이 기초 마킹 기술부터 복잡한 프로젝트 개발까지의 역량을 기르도록 돕습니다。',
        },
        {
          tagTitle: '컴팩트하고 현대적인 디자인',
          desc: 'Mark M20 레이저 마킹기는 컴팩트하고 현대적인 설계로 설치 면적이 작고 소음이 낮으며, 넓은 시창을 갖춰 높은 내구성 요구를 충족합니다。세련된 외관은 안전 기준을 만족해 교육 기관과 공공 리테일 환경에 적합합니다。',
        },
        {
          tagTitle: '몇 초 만에 마킹 완료',
          desc: 'Mark M20은 가장 작은 글꼴을 선택하더라도 몇 초 안에 정밀 마킹을 완료할 수 있습니다。이 뛰어난 속도는 레이저 응용 소프트웨어 LightMaker의 간소화된 워크플로와 효율과 결합되어, 생산성을 크게 향상시킵니다。 ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: '레이저 유형', value: '광섬유 레이저' },
          { key: 'laserPower', label: '레이저 출력', value: '20W / 30W / 50W' },
          {
            key: 'markArea',
            label: '마킹 영역',
            value:
              '표준 110×110mm(필드 렌즈를 교체해 175×175mm 등으로 확장 가능)',
          },
          { key: 'maxHeight', label: '최대 작업 높이', value: '≤130mm' },
          { key: 'connection', label: '연결 방식', value: '이더넷' },
          {
            key: 'os',
            label: '지원 OS',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: '전원',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: '안전 보호',
            value:
              '인터록 스위치(뚜껑 열림 시 정지), 축 리미트, 비상 버튼, 안전 키',
          },
          { key: 'software', label: '지원 소프트웨어', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: '구동 방식',
            value: '마킹 헤드 고정밀 전동 스크루 승강',
          },
          {
            key: 'fileFormat',
            label: '지원 파일',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: '초점 스폿 직경', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: '스마트 데스크톱 레이저 커팅 & 조각기',
      sections: {
        advantages: '우리의 강점',
        aiTitle: 'AI 교육을 현장에 구현',
        aiSubtitle: 'AI+교육 디지털 지능화로 역량 강화, 혁신적 아이디어 융합',
        carouselTitle: '창의 커팅, 여기서 시작',
        specsTitle: '제품 사양',
      },
      bannerFeatures: [
        '빠름 / 오픈형 후면 도어 / 고효율 자동 초점',
        '올인원 레이저 조각·커팅기',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: '작업 영역',
          desc: '탁월한 커팅·조각 결과, 다양한 모델과 레이저 출력 구성으로 다양한 적용 요구를 충족합니다\n레이저 유형：DC CO2\n레이저 출력：60W-130W\nLight640(600*400mm)\nLight960(900*600mm)\nLight1390(1300*900mm)\nLight1610(1600*1000mm)',
        },
        {
          tagTitle: '고효율 자동 초점 + 레드닷 포지셔닝',
          desc: '자동 초점 기능은 커팅·조각 전에 빠르고 정확하게 초점을 맞추고 위치를 정렬합니다。레드닷 포지셔닝 빔으로 작업 위치를 실시간 확인할 수 있어, 커팅·조각 시간을 크게 절약하고 더 나은 가공 결과를 제공합니다。',
        },
        {
          tagTitle: '오픈형 후면 도어 설계',
          desc: '오픈형 후면 도어 설계로 길이 제한 없이 커팅·조각 소재를 투입할 수 있으며, 600mm×∞ 길이의 판재로 작업이 더 편리하고 제약이 줄어듭니다。',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: '탁월한 커팅·조각 작품',
            desc: '레이저 커터는 고정밀 레이저 커팅 플랫폼을 탑재해 목재와 아크릴 등 소재 가공에서 기업급 가공 기준과 효율을 달성합니다。레이저 공예 제품의 대량 생산이 가능해 기업의 생산성과 브랜드 효율을 비약적으로 향상시킵니다。',
          },
          {
            tagTitle: '고급 레이저 튜브와 정밀 부품 탑재',
            desc: '다양한 제품 라인업으로 고객 요구에 따라 레이저 유형과 가공 강도를 선택할 수 있어, 각종 생산 요구를 충족합니다。목재, 유리, 아크릴 등 소재와 공정에 더 폭넓은 적용이 가능합니다。',
          },
          {
            tagTitle: '엄격한 광학 품질 테스트, 품질 보증',
            desc: '생산 라인에서 엄격한 테스트를 수행하며, 정밀한 광로 제어와 5회 이상의 커팅·조각 테스트로 안정적이고 일관된 출력을 갖춘 최상급 CO2 레이저 튜브를 보장합니다。뛰어난 출력 안정성과 정교한 레이저 스폿으로 균일한 조각이 가능하며, 복잡한 디테일까지 구현할 수 있습니다。',
          },
        ],
        light1390: [
          {
            tagTitle: '탁월한 커팅·조각 작품',
            desc: '레이저 커터는 고정밀 레이저 커팅 플랫폼을 탑재해 목재와 아크릴 등 소재 가공에서 기업급 가공 기준과 효율을 달성합니다。레이저 공예 제품의 대량 생산이 가능해 기업의 생산성과 브랜드 효율을 비약적으로 향상시킵니다。',
          },
          {
            tagTitle: '고급 레이저 튜브와 정밀 부품 탑재',
            desc: '다양한 제품 라인업으로 고객 요구에 따라 레이저 유형과 가공 강도를 선택할 수 있어, 각종 생산 요구를 충족합니다。목재, 유리, 아크릴 등 소재와 공정에 더 폭넓은 적용이 가능합니다。',
          },
          {
            tagTitle: '엄격한 광학 품질 테스트, 품질 보증',
            desc: '생산 라인에서 엄격한 테스트를 수행하며, 정밀한 광로 제어와 5회 이상의 커팅·조각 테스트로 안정적이고 일관된 출력을 갖춘 최상급 CO2 레이저 튜브를 보장합니다。뛰어난 출력 안정성과 정교한 레이저 스폿으로 균일한 조각이 가능하며, 복잡한 디테일까지 구현할 수 있습니다。',
          },
        ],
        light1610: [
          {
            tagTitle: '전면적&첨단 안전 기능',
            desc: '1. 비상 정지\n2. 경고등\n3. 방수 스위치\n4. 접지선\n5. 내장 열 감지기 경보는 기기 이상 활동 시 자동으로 켜짐\n6. 잠금 커버 보호\n7. 강화유리 소재의 내구성 보호창',
          },
          {
            tagTitle: '내구성 뛰어나고 품질 탁월',
            desc: '1. 단일 프로젝트부터 대량 생산까지 모두에 적합합니다。\n2. 작업 영역 선택 폭이 넓어 600 x 400MM부터 1600 x 1000MM까지 지원합니다。\n3. 타의 추종을 불허하는 조각 속도。\n4. 업계 전문가 설계。\n5. 개인화, 교육, 산업 응용에 이상적입니다。',
          },
          {
            tagTitle: '스마트 모니터링으로 생산 최적화',
            desc: '가장 고가의 장비 구성 요소(축, 레이저 헤드, 광학 부품, 렌즈)를 먼지와 오염으로부터 보호하도록 설계되어, 고강도 사용 환경에서도 수년간 무고장 운전을 보장합니다。',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Light 640으로 무엇을 할 수 있나요',
          items: [
            {
              title: 'Light 640 - 프로젝트 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - 프로젝트 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - 프로젝트 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - 프로젝트 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - 프로젝트 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - 프로젝트 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - 프로젝트 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - 프로젝트 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Light 960으로 무엇을 할 수 있나요',
          items: [
            {
              title: 'Light 960 - 프로젝트 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - 프로젝트 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - 프로젝트 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - 프로젝트 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - 프로젝트 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - 프로젝트 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - 프로젝트 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - 프로젝트 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Light 1390으로 무엇을 할 수 있나요',
          items: [
            {
              title: 'Light 1390 - 프로젝트 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - 프로젝트 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Light 1610으로 무엇을 할 수 있나요',
          items: [
            {
              title: 'Light 1610 - 프로젝트 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - 프로젝트 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: '냉각 시스템',

          exhaustTitle: '배기 시스템',
        },
        left: [
          { key: 'model', label: '장비 모델', value: 'Light 640' },
          { key: 'workArea', label: '가공 면적', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: '레이저 유형',
            value: '밀봉식 CO₂ 유리 레이저 튜브',
          },
          {
            key: 'laserPower',
            label: '레이저 출력',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Z축 높이',
            value: '135mm(5.3인치)',
          },
          {
            key: 'tableSize',
            label: '작업대 크기',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: '최대 소재 크기(전·후면 도어 닫힘)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: '최대 소재 크기(후면 도어 열림)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: '기기 크기(너비 × 길이 × 높이)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: '기기 무게',
            value: '300kg(660파운드)',
          },
          {
            key: 'maxSpeed',
            label: '최대 작업 속도',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: '위치 정밀도',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: '초점 모드',
            value: '자동 초점 / 수동 초점',
          },
          {
            key: 'resume',
            label: '정전 후 이어서 조각',
            value: '지원',
          },
          {
            key: 'transmission',
            label: '구동 방식',
            value: '고속 스테퍼 모터 + 고정밀 폐루프 모터',
          },
          {
            key: 'connection',
            label: '통신 방식',
            value: 'LAN / USB / Wi‑Fi',
          },
        ],
        right: [
          {
            key: 'software',
            label: '소프트웨어',
            value: 'Good-Laser LightMaker(LightBurn 호환)',
          },
          {
            key: 'process',
            label: '가공 공정',
            value: '선묘, 커팅, 깊은 조각, 얕은 조각',
          },
          {
            key: 'fileFormats',
            label: '지원 파일 형식',
            value: '비트맵: JPG / PNG / BMP; 벡터: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: '주파수',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: '상',
            value: '단상',
          },
          {
            key: 'current',
            label: '전부하 전류',
            value: '6A',
          },
          {
            key: 'voltage',
            label: '전압',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: '총 전력',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: '적용 소재',
            value:
              '목재, 아크릴, 가죽, 직물, 플라스틱, 골판지, 고무, 투톤 보드, 대리석, 유리, 아노다이징 알루미늄 및 기타 비금속 소재',
          },
          {
            key: 'safety',
            label: '안전 기준',
            value:
              'EU CE 안전 기준을 준수하며, 작업실 커버 개방 보호, 냉각 보호 시스템, 온도 제어 자동 경보 시스템, 누전 회로 보호 시스템, 비상 정지 보호 시스템, 광로 시스템, 강화유리 관찰 시스템, 작동 상태 표시등 등을 갖추고 있습니다',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: '냉각 방식',
            value: '수랭',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: '배기구 직경',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: '밀봉식 CO₂ 유리 레이저 튜브',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm(5.3인치)',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg(902파운드)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '자동 초점 / 수동 초점',
          resume: '지원',
          transmission: '고속 스테퍼 모터 + 고정밀 폐루프 모터',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker(LightBurn 호환)',
          process: '선묘, 커팅, 깊은 조각, 얕은 조각',
          fileFormats: '비트맵: JPG / PNG / BMP; 벡터: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '단상',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '목재, 아크릴, 가죽, 직물, 플라스틱, 골판지, 고무, 투톤 보드, 대리석, 유리, 아노다이징 알루미늄 및 기타 비금속 소재',
          safety:
            'EU CE 안전 기준을 준수하며, 작업실 커버 개방 보호, 수랭 보호 시스템, 온도 제어 자동 경보 시스템, 누전 회로 보호 시스템, 비상 정지 보호 시스템, 광로 시스템, 강화유리 관찰 시스템, 작동 상태 표시등 등을 갖추고 있습니다',
          coolingMode: '수랭',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: '밀봉식 CO₂ 유리 레이저 튜브',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm(5.3인치)',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg(1100파운드)',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '자동 초점 / 수동 초점',
          resume: '지원',
          transmission: '고속 스테퍼 모터 + 고정밀 폐루프 모터',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker(LightBurn 호환)',
          process: '선묘, 커팅, 깊은 조각, 얕은 조각',
          fileFormats: '비트맵: JPG / PNG / BMP; 벡터: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '단상',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '목재, 아크릴, 가죽, 직물, 플라스틱, 골판지, 고무, 투톤 보드, 대리석, 유리, 아노다이징 알루미늄 및 기타 비금속 소재',
          safety:
            'EU CE 안전 기준을 준수하며, 작업실 커버 개방 보호, 수랭 보호 시스템, 온도 제어 자동 경보 시스템, 누전 회로 보호 시스템, 비상 정지 보호 시스템, 광로 시스템, 강화유리 관찰 시스템, 작동 상태 표시등 등을 갖추고 있습니다',
          coolingMode: '수랭',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: '밀봉식 CO₂ 유리 레이저 튜브',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm(5.3인치)',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg(1298파운드)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '자동 초점 / 수동 초점',
          resume: '지원',
          transmission: '고속 스테퍼 모터 + 고정밀 폐루프 모터',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker(LightBurn 호환)',
          process: '선묘, 커팅, 깊은 조각, 얕은 조각',
          fileFormats: '비트맵: JPG / PNG / BMP; 벡터: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '단상',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '목재, 아크릴, 가죽, 직물, 플라스틱, 골판지, 고무, 투톤 보드, 대리석, 유리, 아노다이징 알루미늄 및 기타 비금속 소재',
          safety:
            'EU CE 안전 기준을 완전히 준수하며, 커버 개방 보호, 수랭 보호, 온도 경보, 누전 보호, 비상 정지 및 레이저 폐루프 시스템을 갖추고 있습니다',
          coolingMode: '수랭',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: '이메일 주소',
      button: '구독',
    },
    social: {
      tiktok: '틱톡',
      weibo: '위챗 채널',
      wechat: '위챗',
      redbook: '샤오홍슈',
    },
    companyDesc:
      '3-16세 아동·청소년을 위한 과학기술 창의력 교육에 집중하며, 과학기술 창의교육 공간을 운영하고 관련 교육 제품과 과정을 자체 개발합니다。학습 설계 소프트웨어, 레이저 조각, 프로그래밍 등의 콘텐츠 영역을 중심으로 제공합니다。',
    navColumns: [
      {
        title: '제품',
        items: [
          { label: '장비', to: '/product/light530' },
          { label: '키트', to: '/product/kits' },
          { label: '과정', to: '/product/courses' },
        ],
      },
      {
        title: '소프트웨어',
        items: [
          {
            label: 'Zhongze 과학교육 클라우드 플랫폼',
            to: '/software/cloud-platform',
          },
          {
            label: 'Zhongze 과학교육 학습 플랫폼',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: '교육 서비스',
        items: [
          { label: 'AI 교육 솔루션', to: '/edu-services' },
          { label: '과학교육 메이커-초중등', to: '/edu-services/maker-k12' },
          {
            label: '건축 모형-중등 직업교육',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: '문화창의 디자인-고등직업교육',
            to: '/edu-services/cultural-higher-vocational',
          },
          { label: '예술·공예품-대학', to: '/edu-services/arts-university' },
          { label: '과학기술 창의 공간', to: '/edu-services' },
        ],
      },
      {
        title: '서비스 및 지원',
        items: [
          { label: '다운로드 센터', to: '/support/download' },
          { label: '애프터서비스', to: '/support/after-sales' },
        ],
      },
      {
        title: '교육 협력',
        items: [{ label: '교육 협력', to: '/edu-services/cooperation' }],
      },
      {
        title: '회사 소개',
        items: [
          { label: '회사 소개', to: '/about' },
          { label: '뉴스', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: '영업 문의: 18379276683',
      email: '이메일: sam@zz-steam.com',
      address: '주소: Shenzhen Futian Bagua 4th Rd Huashengda Building A',
    },
    qrDesc: '더 알아보기',
  },

  globalContactForm: {
    title: '문의하기',
    subtitle: '아래 양식을 작성해 주세요. 최대한 빠르게 연락드리겠습니다',
    fields: {
      name: '이름',
      email: '이메일',
      phone: '전화',
      company: '회사',
      message: '문의 내용',
    },
    placeholders: {
      name: '이름을 입력해 주세요',
      email: '이메일을 입력해 주세요',
      phone: '전화번호를 입력해 주세요',
      company: '회사명을 입력해 주세요',
      message: '문의 내용을 입력해 주세요',
    },
    submitting: '제출 중...',
    submit: '제출',
    visual: {
      title: '협력을 기대합니다',
      description:
        '전문적인 서비스와 지원을 제공합니다. 궁금한 점이 있으면 언제든 문의해 주세요。',
    },
    contact: {
      phone: '연락처',
      email: '이메일',
    },
    validation: {
      name: '이름을 입력해 주세요',
      email: '이메일을 입력해 주세요',
      emailFormat: '올바른 이메일 형식을 입력해 주세요',
      phone: '전화번호를 입력해 주세요',
      phoneFormat: '유효한 전화번호를 입력해 주세요',
      message: '문의 내용을 입력해 주세요',
    },
    success: '제출이 완료되었습니다! 최대한 빠르게 연락드리겠습니다。',
    networkError: '제출에 실패했습니다. 잠시 후 다시 시도해 주세요。',
  },
};
